module.exports = __webpack_public_path__ + "img/room-reading.d6282ac9.jpg";